import React from 'react';

import Input from '@components/Input';

import { attachmentTagOptions, IAttachmentTagContext } from '@utils/attachmentTag';

interface IAttachmentTagFieldProps {
  context: IAttachmentTagContext;
  value: number | null;
  onChange: (locationUnitId: number | null) => void;
}

const AttachmentTagField = ({ context, value, onChange }: IAttachmentTagFieldProps) => (
  <Input
    field={{
      label: 'Tag to',
      value: value ?? '',
      isRequired: false,
      type: CustomFieldType.PICKLIST,
      options: attachmentTagOptions(context),
    }}
    name="locationUnitId"
    width={12}
    placeholder={typeof context.inspectionUnitId === 'number' ? 'Select unit' : undefined}
    onChange={(event) => {
      const raw = event?.currentTarget?.value ?? event?.target?.value;

      if (raw === '' || raw == null) {
        onChange(null);

        return;
      }

      const parsed = Number(raw);
      onChange(Number.isInteger(parsed) ? parsed : null);
    }}
  />
);

export default AttachmentTagField;
